import React, { Component } from 'react';
import i from '../imports';
import Session from '../services/session';

class DiscountItem extends Component {
    render() {
        let item = this.props.item;
        return (
            <div style={{height: 130, opacity: 1, paddingTop: 20, maxWidth: 400, display: "inline-block"}}>
                <i.Row>
                    <i.Col md={4} xs={4} align="right">
                        <i.Icon icon={i.faIcons[item.icon] || i.faIcons.percent} style={{color: "white"}} size="56" />
                    </i.Col>
                    <i.Col md={8} xs={8} align="left">
                        <div style={{color: "#FF5560", fontSize: 24, fontWeight: "bold", paddingBottom: 10}} >{item.translations[0] ? item.translations[0].title : ""}</div>
                        <div style={{color: "white", fontSize: 18, fontWeight: "normal", paddingBottom: 10}}>{item.translations[0] ? item.translations[0].text : ""}</div>
                        <div><i.NavLink style={{color: "#FF5560", fontSize: 18, fontWeight: "normal", textDecoration: "none"}} to={i.Utils.locUrl(item.name)}>{Session.model.common.learnmore}</i.NavLink></div>
                    </i.Col>
                </i.Row>
            </div>
        );
    }
}

export default DiscountItem;